<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <h1 class="pt-3">Billing</h1>
  <ngb-alert [dismissible]="false" *ngIf="accountSubscriptionType === subscriptionTypes.offline" type="info" class="text-center mt-3">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <tr-icon [icon]="icon.info" [color]="iconColor.primary" classes="pr-2"></tr-icon>

      <p class="my-0">You are licensed for {{ licences }} locations until {{ licenceExpirationDate | trDateFormat : 'MM/DD/yyyy': timezone }}</p>
    </div>
  </ngb-alert>

  <ngb-alert [dismissible]="false" *ngIf="countOfFreeLocations >= appVariables.FREE_PLAN_LOCATION_LIMIT" type="info" class="text-center">
    You have reached the limit of {{appVariables.FREE_PLAN_LOCATION_LIMIT}} Free locations. In order to create a new location or activate an inactive Free location, you must first disable, delete or activate a paid subscription for one of your existing locations.
  </ngb-alert>

  <div class="header">
    <p class="heading color-primary">Subscriptions Information</p>
    <tablesready-search-bar
      placeholder="Search location"
      btnColorClass="btn-light"
      [whiteIconColorEnabled]="false"
      (search)="setFilters({ name: $event })"
    ></tablesready-search-bar>
  </div>

  <div class="d-flex flex-row justify-content-start pb-2" *ngIf="isOffline">
    <div class="sortable p-1">
      <tablesready-sortable-column
        [sortBy]="sortBy"
        column="location"
        title="LOCATION"
        [orderAscending]="sortAsc"
        (orderBy)="orderBy($event)"
      ></tablesready-sortable-column>
    </div>
  </div>

  <div *ngIf="!isOffline; else offlineLocations">
    <div class="scroll-table">
      <table class="table table-sm-bordered tr-table" *ngIf="locationsFiltered">
        <tbody>
        <tr class="d-none d-sm-table-row">
          <th>
            <tablesready-sortable-column
              [sortBy]="sortBy"
              column="location"
              title="Location"
              [orderAscending]="sortAsc"
              (orderBy)="orderBy($event)"
            ></tablesready-sortable-column>
          </th>
          <th>
            <div class="filter-wide">
              <frontend-dropdown
                [items]="dropdownPricePlans"
                [searchable]="false"
                [clearable]="true"
                [(ngModel)]="pricePlanFilter"
                (ngModelChange)="setFilters({ planCode: $event })"
                customClass="old-filter-style"
                placeholder="Subscription plan"
                bindLabel="title"
                bindValue="value"
                maxListHeight="9.3rem"
              ></frontend-dropdown>
            </div>
          </th>
          <th>Price</th>
          <th>
            <tablesready-sortable-column
              [sortBy]="sortBy"
              column="period"
              title="Period ends"
              [orderAscending]="sortAsc"
              (orderBy)="orderBy($event)"
            ></tablesready-sortable-column>
          </th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
        <ng-container *ngFor="let loc of locationsFiltered | slice: start : end;">
          <tr>
            <td>
              <b>{{ loc.name }}</b>
            </td>
            <td>
              <div class="plan-column">
                <tablesready-sms-usage
                  [pricePlan]="pricePlansMap[loc?.recurly?.planCode]"
                  [subscriptionType]="accountSubscriptionType"
                  [usage]="loc?.usage"
                  [showPrice]="!isOffline"
                  [timezone]="timezone"
                ></tablesready-sms-usage>
              </div>
            </td>
            <td><b>${{ loc.pricePlanPrice }}</b></td>
            <td>{{ loc.periodEnds | trDateFormat:'MM/DD/yyyy': timezone }}</td>
            <td><tablesready-subscription-state [state]="loc.subscriptionState"></tablesready-subscription-state></td>
            <td>
              <div class="manage-column">
                <button class="btn btn-info" [disabled]="!loc.enabled" (click)="manageLocation(loc._id)">Manage</button>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
    <div class="pagination">
      <ngb-pagination
        [(page)]="locationPageIndex"
        [pageSize]="locationPageSize"
        [maxSize]="maxDisplayPages"
        [ellipses]="true"
        [collectionSize]="locationsFiltered.length"
      ></ngb-pagination>
    </div>
  </div>

  <div class="header" *ngIf="showBillingInfo">
    <p class="heading color-primary">Payment Info</p>
    <tablesready-collapse-toggle
      [active]="paymentInfoVisible"
      (activeChange)="paymentInfoVisible = !paymentInfoVisible"
    ></tablesready-collapse-toggle>
  </div>
  <div class="scroll-table">
    <table class="table table-sm-bordered tr-table" *ngIf="showBillingInfo">
      <tbody>
      <tr class="d-none d-sm-table-row">
        <th>Name</th>
        <th>Address</th>
        <th>Card</th>
        <th>Billing email</th>
        <th></th>
      </tr>
      <tr *ngIf="paymentInfoVisible && billingInfo !== undefined">
        <td>
          <p class="center">{{ billingInfo.first_name + ' ' + billingInfo.last_name }}</p>
        </td>
        <td>
          <p class="center">{{ billingInfo.address1 + ', '  + billingInfo.zip }}</p>
        </td>
        <td>
          <span class="center glyphicon glyphicon-credit-card"></span>
          <p class="center">{{ billingInfo.card_type + ' ending in ' + billingInfo.last_four }}</p>
        </td>
        <td>
          <p class="center">{{ email }}</p>
        </td>
        <td class="edit-column">
          <button
            type="button"
            class="btn btn-info"
            (click)="updateBillingModal()"
            [disabled]="accountSubscriptionType === subscriptionTypes.offline"
            id="modify-payment-button"
          >
            <p class="edit-info">Edit information</p>
            <tr-icon [icon]="icon.edit" [color]="iconColor.white"></tr-icon>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="add-info my-4" *ngIf="!billingInfo && accountSubscriptionType !== subscriptionTypes.offline">
    <button type="button" class="btn btn-info" (click)="updateBillingModal(true)">Add billing info</button>
  </div>

  <div *ngIf="accountCode">
    <div *ngIf="!isOffline">
      <div class="header">
        <p class="heading color-primary">Discount code</p>
      </div>
      <tablesready-admin-apply-discount-code [coupon]="discountCode"></tablesready-admin-apply-discount-code>
    </div>

    <div *ngIf="subscriptions.length">
      <tablesready-invoices
        [timezone]="timezone"
      ></tablesready-invoices>
    </div>
  </div>
</section>

<ng-template #offlineLocations>
  <tablesready-billing-offline-locations
    [locations]="locationsFiltered"
    [accountSubscriptionType]="accountSubscriptionType"
  ></tablesready-billing-offline-locations>
</ng-template>
